<template>
  <div class="w-full flex flex-wrap items-center gap-4">
    <div v-for="(legend, index) in legends" :key="index" class="hidden md:flex justify-start px-1">
      <legend-table :legendColor="legend.color" :text="legend.text" :swatch="legend.swatch" />
    </div>

    <div class="flex justify-center">
      <ghost-button
        text="Ver legenda completa"
        width="100%"
        density="compact"
        :prependIcon="mdiMapLegend"
        @click="showAllLegends"
      />
    </div>
  </div>

  <teleport to="#app">
    <legends-modal />
  </teleport>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import LegendTable, { ELegendColor } from '@/components/others/Legend.vue'
import LegendsModal from './legends.modal.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { mdiMapLegend } from '@mdi/js'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { COVERAGE_STATUS_SHORT_LABELS } from '@/utils/coverage'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import { useLegendShowsUnidentified } from './useLegendShowsUnidentified'
import { stationPalette } from '@/theme/stationPalette'

const modalStore = useModalStore()

const showUnidentified = useLegendShowsUnidentified()

// Paleta v3: bolinhas com os hex da paleta; antiga: classes de hoje (swatch vazio).
const palette = stationPalette()
const swatch = (hex: string) => (palette.id === 'legacy' ? '' : hex)

const baseLegends = [
  { text: 'Aberta', color: ELegendColor.alert, swatch: swatch(palette.open.stripe) },
  { text: 'Fixo', color: ELegendColor.default, swatch: swatch(palette.type.FIXO.stripe) },
  {
    text: 'Cobertura',
    color: ELegendColor.warning,
    swatch: swatch(palette.type.COBERTURA.stripe)
  },
  { text: 'Extra', color: ELegendColor.success, swatch: swatch(palette.type.EXTRA.stripe) }
]

// "Ocupado s/ ident." só quando a resposta conhece o estado (mesma regra da legenda V2).
const legends = computed(() =>
  showUnidentified.value
    ? [
        ...baseLegends,
        {
          text: COVERAGE_STATUS_SHORT_LABELS[CoverageStatus.UNIDENTIFIED],
          color: ELegendColor.unidentified,
          swatch: ''
        }
      ]
    : baseLegends
)

const showAllLegends = () => {
  modalStore.toggleModal(EModals.LEGENDS)
}
</script>
